import t from "../../theme";

export const useGetRewardsScreenStyles = () => {
  return {
    pageContainer: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      backgroundColor: "transparent",
    },
    drawerContainer: {
      "& .MuiBackdrop-root": {
        opacity: "0 !important",
        backgroundColor: "transparent",
      },
    },
    drawer: {
      backdropFilter: t.blur.heavy,
      backgroundColor: t.glass.secondary,
      minHeight: "30%",
      boxShadow: t.shadow.lg,
      zIndex: "1255 !important",
    },
    titleBanner: {
      height: 50,
      background: "#2e7d32",
      marginBottom: 12,
      display: "flex",
      alignItems: "center",
      padding: "0 35px",
      justifyContent: "space-between",
      color: t.brand.white,
      position: "relative",
      boxShadow: "0 4px 20px rgba(46, 125, 50, 0.25)",
      "& h1": {
        color: "inherit",
        fontSize: "18px",
        fontWeight: 600,
        margin: 0,
        textShadow: "0 2px 4px rgba(0,0,0,0.1)",
      },
      "@media (max-width: 768px)": {
        height: 44,
        padding: "0 16px",
        "& h1": {
          fontSize: "15px",
        },
      },
    },
    detailsWrapper: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      padding: "0 35px",
      marginBottom: 10,
    },
    header: {
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0.72) 100%)",
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      border: "1px solid rgba(46, 125, 50, 0.1)",
      borderRadius: t.radius.lg,
      boxShadow:
        "0 4px 16px rgba(46, 125, 50, 0.06), 0 1px 3px rgba(0,0,0,0.04)",
      display: "flex",
      gap: 32,
      padding: "24px 28px",
      alignItems: "center",
      transition: t.transition.smooth,
    },
    progressWrapper: {
      flex: 1,
    },
    userTypeTitle: {
      marginBottom: 8,
    },
    subWraper: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginBottom: 8,
    },
    radioGroup: {
      margin: "8px 0",
      "& .ant-radio-group": {
        background:
          "linear-gradient(135deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.65) 100%)",
        backdropFilter: t.blur.medium,
        WebkitBackdropFilter: t.blur.medium,
        borderRadius: t.radius.pill,
        padding: "4px",
        border: "1px solid rgba(46, 125, 50, 0.1)",
        boxShadow: "0 2px 8px rgba(46, 125, 50, 0.04)",
      },
      "& .ant-radio-button-wrapper": {
        borderRadius: t.radius.pill,
        border: "none",
        background: "transparent",
        color: t.text.secondary,
        fontWeight: 500,
        fontSize: "13px",
        padding: "4px 20px",
        height: "auto",
        lineHeight: "28px",
        transition: t.transition.fast,
        "&::before": {
          display: "none",
        },
        "&:hover": {
          color: "#2e7d32",
        },
      },
      "& .ant-radio-button-wrapper-checked": {
        background: t.green.gradient + " !important",
        color: t.brand.white + " !important",
        boxShadow: "0 2px 8px rgba(46, 125, 50, 0.3) !important",
        border: "none !important",
        fontWeight: 600,
      },
    },
    progressBarTitle: {
      fontSize: 13,
      color: t.text.muted,
      marginTop: 8,
      fontWeight: 500,
    },
    brandCardsWrapper: {
      display: "flex",
      flexWrap: "wrap",
      margin: "20px auto",
      maxWidth: "90%",
      justifyContent: "center",
      gap: "15px",
      padding: "24px 20px",
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.75) 0%, rgba(255,255,255,0.6) 100%)",
      backdropFilter: t.blur.medium,
      WebkitBackdropFilter: t.blur.medium,
      borderRadius: t.radius.lg,
      border: "1px solid rgba(46, 125, 50, 0.1)",
      boxShadow: "0 4px 16px rgba(46, 125, 50, 0.06)",
    },
    balanceDetails: {
      display: "flex",
      flexDirection: "column",
      gap: 3,
    },
    balanceDetailsTextLight: {
      fontSize: 10,
      color: t.text.muted,
      fontWeight: 400,
      display: "flex",
      gap: 5,
      alignItems: "center",
      "& > span": {
        opacity: 0.34,
      },
    },
    balanceDetailsTextStrong: {
      fontSize: 18,
      color: t.text.primary,
      fontWeight: 500,
    },
    tandctag: {
      backgroundColor: "rgba(46, 125, 50, 0.06)",
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      color: t.text.muted,
      padding: "6px 14px",
      fontSize: 12,
      border: "1px solid rgba(46, 125, 50, 0.12)",
      borderRadius: t.radius.pill,
      cursor: "pointer",
      fontWeight: 500,
      transition: t.transition.fast,
      "&:hover": {
        backgroundColor: "rgba(46, 125, 50, 0.12)",
        color: t.text.primary,
      },
    },
    redeemBtn: {
      maxWidth: 150,
      background: t.green.gradient,
      color: t.brand.white,
      fontSize: 13,
      fontWeight: 600,
      padding: "8px 22px",
      height: 36,
      borderRadius: t.radius.pill,
      border: "none",
      boxShadow: "0 2px 8px rgba(46, 125, 50, 0.3)",
      transition: t.transition.fast,
      "&:hover": {
        boxShadow: "0 4px 12px rgba(46, 125, 50, 0.45)",
        transform: "translateY(-1px)",
      },
    },
    body: {
      display: "flex",
      borderRadius: t.radius.lg,
      overflow: "hidden",
      border: "1px solid rgba(46, 125, 50, 0.12)",
      boxShadow:
        "0 4px 20px rgba(46, 125, 50, 0.07), 0 1px 4px rgba(0,0,0,0.04)",
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.35) 100%)",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
      margin: "0 35px",
    },
    leftCategoriesPanel: {
      width: 160,
      background:
        "linear-gradient(180deg, rgba(255,255,255,0.78) 0%, rgba(255,255,255,0.68) 100%)",
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      color: t.text.primary,
      maxHeight: "100%",
      overflow: "auto",
      borderRight: "1px solid rgba(46, 125, 50, 0.1)",
    },
    rightDetailsPanel: {
      display: "flex",
      flexDirection: "column",
      padding: "20px 50px",
      width: "100%",
    },
    categoryListItem: {
      display: "flex",
      padding: "10px 16px",
      margin: "2px 8px",
      gap: 12,
      alignItems: "center",
      borderRadius: t.radius.md,
      cursor: "pointer",
      transition: t.transition.smooth,
      fontWeight: 500,
      fontSize: "13px",
      color: t.text.secondary,
      border: "1px solid transparent",
      "&:hover": {
        backgroundColor: "rgba(46, 125, 50, 0.06)",
        border: "1px solid rgba(46, 125, 50, 0.1)",
        color: t.text.primary,
      },
    },
    earnMoneyBtn: {
      maxWidth: 155,
      background: t.green.gradient,
      color: t.brand.white,
      fontSize: 14,
      fontWeight: 600,
      borderRadius: t.radius.pill,
      boxShadow: "0 4px 12px rgba(46, 125, 50, 0.3)",
    },
    flexColItem: {
      display: "flex",
      flexDirection: "column",
      gap: 5,
    },
    flexRowItem: {
      display: "flex",
      gap: 20,
    },
    cardContainer: {
      display: "flex",
      gap: 14,
      padding: "16px 20px",
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.65) 100%)",
      backdropFilter: t.blur.medium,
      WebkitBackdropFilter: t.blur.medium,
      flex: 1,
      borderRadius: t.radius.md,
      border: "1px solid rgba(46, 125, 50, 0.1)",
      boxShadow: "0 2px 8px rgba(46, 125, 50, 0.04)",
      transition: t.transition.smooth,
      alignItems: "center",
      "&:hover": {
        boxShadow:
          "0 4px 12px rgba(46, 125, 50, 0.08), 0 1px 3px rgba(0,0,0,0.04)",
        transform: "translateY(-1px)",
      },
    },
    offerDetailsContentWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "70px 0",
      gap: "50px",
      justifyContent: "center",
    },
    cardImg: {
      width: 45,
      height: 45,
    },
    cardTitle: {
      margin: 0,
      color: t.text.primary,
      fontSize: 18,
      fontWeight: 600,
    },
    cardDes: {
      margin: 0,
      color: t.text.muted,
      fontSize: 16,
    },
    accordionWrapper: {
      display: "flex",
      gap: 10,
      flexDirection: "column",
      marginTop: 20,
    },

    /* ─── Favourites Grid ────────────────────────────────── */
    brandCardsInSearchWrapper: {
      display: "flex",
      flexWrap: "wrap",
      gap: 20,
      justifyContent: "center",
      marginTop: 24,
      marginBottom: 40,
      padding: "28px 20px",
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.65) 0%, rgba(255,255,255,0.5) 100%)",
      backdropFilter: t.blur.medium,
      WebkitBackdropFilter: t.blur.medium,
      borderRadius: t.radius.lg,
      border: "1px solid rgba(46, 125, 50, 0.1)",
      boxShadow:
        "0 4px 16px rgba(46, 125, 50, 0.06), 0 1px 3px rgba(0,0,0,0.04)",
    },
    categoryWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "10px",
    },
    backArrow: {
      position: "absolute",
      top: 20,
      left: 8,
    },

    /* ─── Search ─────────────────────────────────────────── */
    searchWrapper: {
      position: "relative",
      display: "flex",
      alignItems: "center",
    },
    searchIcon: {
      position: "absolute",
      left: 12,
      width: 28,
      height: 28,
      color: t.text.placeholder,
    },
    search: {
      height: "42px",
      fontSize: "14px",
      width: "100%",
      paddingLeft: "48px",
      paddingRight: "16px",
      fontWeight: 400,
      borderRadius: t.radius.pill,
      border: "1px solid rgba(46, 125, 50, 0.15)",
      boxShadow: "0 2px 8px rgba(46, 125, 50, 0.04)",
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0.72) 100%)",
      backdropFilter: t.blur.medium,
      WebkitBackdropFilter: t.blur.medium,
      outline: "none",
      transition: t.transition.fast,
      color: t.text.primary,
      "&::placeholder": {
        color: t.text.placeholder,
        fontWeight: 400,
      },
      "&:focus": {
        borderColor: "#2e7d32",
        boxShadow:
          "0 0 0 3px rgba(46, 125, 50, 0.12), 0 2px 8px rgba(46, 125, 50, 0.06)",
      },
    },
  };
};
